import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import useQuiz from '../../hooks/useQuiz';
import handleCantReserve from '../../utils/functions/handleCantReserve';
import { ReservationService } from '../../services';

import Head from '../../components/Head';
import Layout from '../../layout';
import Start from './Start';
import Quiz from './Quiz';
import QuizOk from './QuizOk';
import QuizNotOk from './QuizNotOk';

const MyHealth = () => {
  const history = useHistory();
  const { isSuspect } = useQuiz();

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    const fetchCanReserve = async () => {
      setLoading(true);
      try {
        const { data } = await ReservationService.canReserve();
        if (!data.can) {
          handleCantReserve(data.reason);
          history.replace('/agendamentos');
        } else return;
      } catch (error) {
        console.log(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCanReserve();
  }, [history]);

  const goBack = useCallback(() => setCurrentPage(0), []);
  const goForward = useCallback(() => setCurrentPage((value) => value + 1), []);

  const renderPage = () => {
    const IsSuspectResponse = isSuspect.some((item) => item);
    // console.log(IsSuspectResponse);
    switch (currentPage) {
      case 0:
        return <Start goForward={goForward} />;
      case 1:
        return <Quiz goToStart={goBack} goToEnd={goForward} />;
      case 2:
        return !IsSuspectResponse ? <QuizOk /> : <QuizNotOk />;
    }
  };

  return (
    <Layout
      page="myHealth"
      backLink="/agendamentos"
      hideBackButton={currentPage === 2}
      loading={loading}
      innerPage
    >
      <Head>Minha Saúde | Quiz</Head>
      {renderPage()}
    </Layout>
  );
};

export default MyHealth;
